'use client';

import { EntitlementsProvider } from '@contexts/EntitlementsContext';
import { AtomicContext } from '@contexts/coveo/AtomicContext';
import { AtomicLayoutSection } from '@coveo/atomic-react';
import { useFlags } from '@lib/flags/amplitude/client';
import { FLAG_TREATMENT, Flags } from '@lib/flags/flagConstants';
import { Tag } from '@lib/types/common/Tag';
import c from 'classnames';
import { useContext } from 'react';
import { HeadlessProductCardWrapper } from '../Search/HeadlessProductCardWrapper';
import { useResults } from '../Search/hooks/useResults';

type Props = {
  productTags?: Tag[];
  context: AtomicContext;
};

export const AtomicResultsSection = ({ productTags, context }: Props) => {
  const { searchEngine } = useContext(context);
  const { results: resultState } = useResults(searchEngine);
  const { flags } = useFlags();
  const isNewSpacingEnabled =
    flags[Flags.UI_AND_MISSING_FILTERS]?.value === FLAG_TREATMENT;

  return (
    <EntitlementsProvider>
      <AtomicLayoutSection data-test="search-result-section" section="results">
        {resultState?.results && resultState.results.length > 0 && (
          <ul
            data-test="search-results-list"
            className={c(
              'grid justify-evenly gap-4',
              isNewSpacingEnabled
                ? 'grid-cols-1 min-[392px]:grid-cols-2 min-[580px]:grid-cols-3 min-[1292px]:grid-cols-4'
                : 'grid-cols-2 md:grid-cols-4 lg:grid-cols-3 lg:gap-5 lg:gap-y-2 2xl:grid-cols-4'
            )}
          >
            {resultState?.results.map((result) => (
              <li key={result.raw.ec_product_id as string}>
                <HeadlessProductCardWrapper
                  context={context}
                  result={result}
                  allProductTags={productTags}
                />
              </li>
            ))}
          </ul>
        )}
      </AtomicLayoutSection>
    </EntitlementsProvider>
  );
};
